import clsx from "clsx";
import { ISentBondTicket } from "@/store/tradeFromScratchStore";
import { returnSentAtTimeLabel } from "../helper/ticketSharedHelper";

// The status line under every ticket's header, as the draft leg detail has it. A sent ticket
// is empty, so it is also "missing" everything - the confirmation takes the slot instead.
// The slot keeps one line's height when empty so the fields below never shift.
interface ITicketStatusLine {
  testIdPrefix: string;
  lastSent: ISentBondTicket | undefined;
  missingFields: string[];
  hasDateIssue?: boolean;
  isBlocking: boolean;
}

const StatusText = ({
  testIdPrefix,
  lastSent,
  missingFields,
  hasDateIssue = false,
  isBlocking,
}: ITicketStatusLine) => {
  if (lastSent) {
    return (
      <div
        data-testid={`${testIdPrefix}SentConfirmation`}
        id={`${testIdPrefix}SentConfirmation`}
        className="text-xs font-semibold text-green-600 dark:text-green-400"
      >
        Sent {returnSentAtTimeLabel(lastSent.sentAt)} - {lastSent.summary} to
        Trade Creation
      </div>
    );
  }
  if (missingFields.length === 0 && !hasDateIssue) return null;
  return (
    <div
      data-testid={`${testIdPrefix}MissingFields`}
      id={`${testIdPrefix}MissingFields`}
      className={clsx(
        "text-xs transition-colors",
        isBlocking
          ? "font-semibold text-red-600 dark:text-red-400"
          : "text-gray-500 dark:text-gray-400",
      )}
    >
      {missingFields.length > 0
        ? `Missing: ${missingFields.join(", ")}`
        : "Check the highlighted dates"}
    </div>
  );
};

const TicketStatusLine = (props: ITicketStatusLine) => (
  <div
    data-testid={`${props.testIdPrefix}StatusLine`}
    id={`${props.testIdPrefix}StatusLine`}
    className="min-h-[1rem] px-1"
  >
    <StatusText {...props} />
  </div>
);

export default TicketStatusLine;
